import { SvgIcon } from "@mui/material";

export const CopilotIcon = () => {
  return (
    <SvgIcon>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4746 1.84615C12.1085 1.84615 11.7472 1.86549 11.3917 1.90315C10.8847 1.95684 10.4302 1.58939 10.3765 1.08242C10.3228 0.575456 10.6903 0.120953 11.1972 0.0672614C11.6172 0.0227797 12.0434 0 12.4746 0C13.3785 0 14.2601 0.100102 15.1086 0.290188C20.4687 1.49105 24.4746 6.27662 24.4746 12C24.4746 18.6274 19.102 24 12.4746 24C5.84719 24 0.474609 18.6274 0.474609 12C0.474609 7.88653 2.54515 4.2569 5.69664 2.09625C5.89815 1.95809 6.01172 1.88246 6.07661 1.84483C6.08794 1.83826 6.1082 1.82672 6.13323 1.81414C6.13335 1.81407 6.13359 1.81395 6.13395 1.81377C6.14292 1.80913 6.22423 1.76709 6.33188 1.74067C6.36622 1.73224 6.42837 1.71893 6.5074 1.71508C6.57556 1.71175 6.73227 1.71084 6.91211 1.78686C7.12782 1.87805 7.33838 2.06715 7.43092 2.35253C7.45379 2.42306 7.46636 2.49026 7.47208 2.55227L11.2273 16.7797L12.9769 13.3455C13.1277 13.0495 13.4259 12.8574 13.7578 12.8424L17.5189 12.6724L11.7772 8.03328L12.7664 11.6742C12.9001 12.1662 12.6096 12.6734 12.1177 12.807C11.6257 12.9407 11.1185 12.6502 10.9849 12.1583L9.24765 5.76453C9.14269 5.37823 9.29869 4.9683 9.63392 4.74951C9.96914 4.53071 10.4072 4.55292 10.7186 4.8045L20.573 12.7666C20.8714 13.0077 20.9896 13.4081 20.8699 13.7726C20.7503 14.137 20.4177 14.3894 20.0346 14.4068L14.378 14.6624L11.7744 19.7726C11.6006 20.1137 11.2343 20.3122 10.8537 20.2714C10.4731 20.2307 10.1571 19.9593 10.0594 19.5892L5.99323 4.18343C3.74818 6.04705 2.32076 8.85692 2.32076 12C2.32076 17.6078 6.86679 22.1538 12.4746 22.1538C18.0824 22.1538 22.6285 17.6078 22.6285 12C22.6285 7.15927 19.2401 3.10773 14.705 2.09168C13.9881 1.93108 13.2418 1.84615 12.4746 1.84615Z"
          fill="url(#paint0_linear_3969_231343)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3969_231343"
            x1="17.8592"
            y1="21.7692"
            x2="5.39769"
            y2="-3.07692"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#358BCA" />
            <stop offset="1" stopColor="#36EDB9" />{" "}
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};
